import React from 'react';
import { XCircle } from 'lucide-react';
export function ProblemStrip() {
  const problems = ['¿Rentas de apartamentos negadas?', '¿Intereses altísimos en préstamos?', '¿Imposible comprar tu propia casa?', '¿Llamadas constantes de cobradores?'];
  return <section className="bg-slate-50 py-12 border-b border-slate-200" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 flex-wrap" data-id="element-137">
          {problems.map((problem, index) => <div key={index} className="flex items-center gap-3" data-id="element-138">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-139" />
              <span className="text-slate-700 font-medium text-lg" data-id="element-140">
                {problem}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}